import { ServiceHelper } from "components/helpers/index";
import { LanguageHelper } from "@parksandresorts/core";
class JetshopJetpassService {
  constructor() {
    this.myParksUrl = process.env.GATSBY_MY_PARKS_URL || "https://prs-cdp-dev-myparks-webapp.azurewebsites.net/api";

    this.additionalOptions = {
      headers: {
        "X-Company": process.env.GATSBY_MY_PARKS_COMPANY || "TestSSL",
        "X-Language": LanguageHelper.getCurrentLocale(),
      },
    };
  }

  getJetpassTimeslotsGLK(glkid, date) {
    return ServiceHelper.fetchGet(
      `/queuepasses/timeslots?productId=${glkid}&date=${date}`,
      this.additionalOptions,
      this.myParksUrl
    );
  }
}

const helper = new JetshopJetpassService();
export default helper;
